import NotificationEventBus from '~/core/events/notification'
import VoucherPurchaseAPIRepository from '~/core/ts/repository/voucher-purchase/VoucherPurchaseAPIRepository'

import { VoucherPurchase } from '~/core/ts/entity/VoucherPurchase'

export function useVoucherPurchaseGetter(uuid: string) {
  const voucherPurchase = ref<VoucherPurchase | null>(null)

  async function getVoucherPurchase(): Promise<VoucherPurchase | null> {
    try {
      // Ésto puede fallar a veces porque se ejecuta el GET mientras la compra todavía se está actualizando.
      //   Retornamos 'null' en ese caso.
      const purchase = await VoucherPurchaseAPIRepository.get(uuid)
      voucherPurchase.value = purchase

      return purchase
    }
    catch (error: any) {
      console.error(error)

      NotificationEventBus.error(
        'an-error-has-ocurred',
        'voucher-cannot-be-located-support'
      )

      return null
    }
  }

  return {
    voucherPurchase,
    getVoucherPurchase,
  }
}
